export const colors = {
  primary: '#5843E4',
  secondary: '#8186A0',
  background: '#E5E5E5',
  backgroundLight: '#F9F9FC',
}

export const chartColors = [
  {
    color: 'hsl(171, 100%, 41%)',
    tag: 'is-primary',
    lightcolor: 'hsl(171, 100%, 96%)',
    lighttag: 'has-background-primary-light',
  },
  {
    color: 'hsl(207, 61%,  53%)',
    tag: 'is-info',
    lightcolor: 'hsl(206, 70%, 96%)',
    lighttag: 'has-background-info-light',
  },
  {
    color: 'hsl(44,  100%, 77%)',
    tag: 'is-warning',
    lightcolor: 'hsl(48, 100%, 96%)',
    lighttag: 'has-background-warning-light',
  },
  {
    color: 'hsl(153, 53%,  53%)',
    tag: 'is-success',
    lightcolor: 'hsl(142, 52%, 96%)',
    lighttag: 'has-background-success-light',
  },
  {
    color: 'hsl(348, 86%, 61%)',
    tag: 'is-danger',
    lightcolor: 'hsl(347, 90%, 96%)',
    lighttag: 'has-background-danger-light',
  },
  {
    color: 'hsl(229, 53%, 53%)',
    tag: 'is-link',
    lightcolor: 'hsl(219, 70%, 96%)',
    lighttag: 'has-background-info-light-light',
  },

  {
    color: 'hsl(0, 0%, 21%)',
    tag: 'is-dark',
    lightcolor: 'hsl(0, 0%, 71%)',
    lighttag: 'has-background-grey-light',
  },
  {
    color: 'hsl(0, 0%, 96%)',
    tag: 'is-light',
    lightcolor: 'hsl(0, 0%, 96%)',
    lighttag: 'has-background-white-ter',
  },
]

export const sessionColors = {
  headerCl: 'has-background-warning-light mr-2',
  itemWhite: 'white',
  itemNotSelectedNotGreyBg: 'white',
  itemNotSelectedGreyBg: 'hsl(206, 70%, 96%)',
  itemSelectedBg: '#0275d8',
  itemText: 'black',
  itemTextSelected: 'white',
}

export const boardColors = {
  headerCl: 'has-background-info-light mr-2',
  itemWhite: 'white',
  itemNotSelectedNotGreyBg: 'white',
  itemNotSelectedGreyBg: 'hsl(48, 100%, 98%)',
  itemSelectedBg: '#0275d8',
  itemText: 'black',
  itemTextSelected: 'white',
}

export const sailColors = {
  headerCl: 'has-background-info-light mr-2',
  itemWhite: 'white',
  itemNotSelectedNotGreyBg: 'white',
  itemNotSelectedGreyBg: 'hsl(171, 100%, 98%)',
  itemSelectedBg: '#0275d8',
  itemText: 'black',
  itemTextSelected: 'white',
}

export const speedAndDistanceColors = {
  headerCl: 'has-background-info-light mr-2',
  itemWhite: 'white',
  itemNotSelectedNotGreyBg: 'white',
  itemNotSelectedGreyBg: 'hsl(171, 100%, 98%)',
  itemSelectedBg: '#0275d8',
  itemText: 'black',
  itemTextSelected: 'white',
}

export const w_speed_and_distance = [20, 20, 20, 40]

export const sessionsNumberOfItemsPerPage = 10
export const boardsNumberOfItemsPerPage = 10
export const sailsNumberOfItemsPerPage = 10
export const globalStatsNumberOfItemsPerPage = 6
export const boardStatsNumberOfItemsPerPage = 10
export const sailStatsNumberOfItemsPerPage = 10
export const meteoNumberOfItemsPerPage = 5

export const blueOptions = { color: 'blue', weight: '1' }

export const months = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
]

export const k_R = 6371e3
export const k_radius = 30000 //balises around 30 km
export const k_max_duration_wm = 7 * 24 * 3600
export const k_max_duration_pioupiou = 31 * 24 * 3600

export const k_kmh_to_knts = 0.539957
export const k_one_hour = 3600000

export const k_session_removed = 'Session removed'
export const k_get_wind_stats_error = 'Error getting wind stats'
export const k_delete_wind_stats_error = 'Error deleting wind stats'
export const k_delete_tzips_error = 'Error deleting tzips'
export const k_delete_rigs_error = 'Error deleting rigs'
export const k_delete_session_error = 'Error deleting session'

export const textClass = 'is-size-6-desktop is-size-7-mobile'
export const smallTextClass = 'is-size-7'

export const react_p = process.env.REACT_APP_PAYPAL

export const kGlobalView = 0
export const kPathView = 1
export const kGPSDataView = 2
export const kRigsUsedView = 3
export const kMeteoView = 4
